'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var ButtonLink = require('../../01.atoms/ButtonLink/ButtonLink.js');
var ButtonPlain = require('../../01.atoms/ButtonPlain/ButtonPlain.js');
var RichText = require('../../01.atoms/RichText/RichText.js');
require('./_index.scss.js');

var _excluded = ["className", "content", "cta", "linkTitle", "link"];
var CLASSNAME = 'varta-rich-text-content',
    cnButton = "".concat(CLASSNAME, "__button");
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function RichTextContent(_ref) {
  var className = _ref.className,
      content = _ref.content,
      cta = _ref.cta,
      linkTitle = _ref.linkTitle,
      link = _ref.link,
      props = _rollupPluginBabelHelpers.objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(CLASSNAME, className)
  }, content && /*#__PURE__*/React__default.createElement(RichText, _rollupPluginBabelHelpers.extends({
    content: content
  }, props)), link && (cta ? /*#__PURE__*/React__default.createElement(ButtonPlain, {
    title: linkTitle,
    link: link,
    className: cnButton
  }) : /*#__PURE__*/React__default.createElement(ButtonLink, {
    title: linkTitle,
    link: link,
    iconId: "caret-right",
    bold: true,
    type: "secondary",
    className: cnButton
  })));
}
RichTextContent.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** True if should be cta button */
  cta: PropTypes.bool,

  /** Content text */
  content: PropTypes.string,

  /** Link text */
  linkTitle: PropTypes.string,

  /** URL to go to */
  link: PropTypes.string
};

module.exports = RichTextContent;
